import React from 'react'
import ReactSelect from 'react-select'
import PropTypes from 'prop-types'
import MenuList from './MenuList'

function Select(props) {
  return (
    <ReactSelect
      {...props}
      captureMenuScroll={false}
      components={{ MenuList }}
    />
  )
}

Select.propTypes = {
  className: PropTypes.string,
  classNamePrefix: PropTypes.string,
}

Select.defaultProps = {
  className: 'react-select',
  classNamePrefix: 'react-select'
}


export default React.memo(Select)
